<template>
    <!--================ Start Header Menu Area =================-->
    <div class="wrap_head" :class="{ 'fixed': scrollTop >= 72 }">
        <div class="head_con">
            <router-link class="logo" to="/">
                <img src="../assets/logo.png" alt="">
                <!-- <h1>徐州地铁集团</h1> -->
            </router-link>
            <ul class="menu_list" style="transform: translate(0px, 0px); opacity: 1;">
                <li class="menu_item" @mouseenter="menuChange(item)" @mouseleave="menuChange({
                    value: -1
                })" :class="{ 'active': item.value == activeIndex }" v-for="(item, index) in menuList"
                    :key="item.vaule">
                    <router-link class="txt" :to="item.path">{{ item.name }}</router-link>
                </li>
            </ul>
            <div class="user_area" v-if="hasLogin" to="/user">
                <el-dropdown @command="handleCommand">
                    <span class="el-dropdown-link logout">
                        <span class="nickName">{{ user.nickname }}</span>
                        <!-- <img class="tx" :src="user.avatar" alt=""> -->
                        <div class="tx">
                            <el-image :src="user.avatar" fit="cover" style="width: 100%;height: 100%;border-radius: 50%;">
                                <div slot="error" class="image-slot" style="font-size: 20px;">
                                    <i class="el-icon-picture-outline"></i>
                                </div>
                            </el-image>
                        </div>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="a">个人中心</el-dropdown-item>
                        <el-dropdown-item command="b">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <div class="logo_area" v-else="hasLogin">
                <router-link class="txt" to="/login">登录</router-link>/<router-link class="txt" to="#">注册</router-link>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
    name: 'Header',
    computed: mapState(['user', 'hasLogin']),
    data() {
        return {
            scrollTop: 0,
            activeIndex: -1,
            menuList: [{ name: '首页', value: 0, path: '/' }, { name: '课程中心', value: 1, path: '/course' }, { name: '在线考试', value: 2, path: '/examination' }, { name: '通知公告', value: 3, path: '/announcement' }, { name: '个人中心', value: 4, path: '/user' }]
        }
    },
    mounted() {
        console.log(this.user);
        window.addEventListener('scroll', this.handleScroll) // 监听页面滚动
    },
    methods: {
        // 获取页面滚动距离
        handleScroll() {
            this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        },
        menuChange(item) {
            this.activeIndex = item.value;
        },
        loginDo() {
            this.$router.push('/login');
        },
        goHome() {
            this.$router.push('/');
        },
        registerTo() {
            this.$router.push('/register');
        },
        userTo() {
            this.$router.push('/userCenter/profile');
        },
        suxueTo() {
            this.$router.push('/suxueCode');
        },
        handleCommand(command) {
            if (command == 'a') {
                this.$router.push('/user');
            } else if (command == 'b') {
                this.quitFun();
            }
        },
        quitFun() {
            console.log("=====");
            this.$confirm('确定退出登录吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$store.dispatch('LogOut').then(() => {
                    this.$message({
                        type: 'success',
                        message: '退出成功!'
                    });
                    // location.reload() // 为了重新实例化vue-router对象 避免bug
                    this.$router.push('/')
                })
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.fixed {
    position: fixed !important;
    top: 0;
    left: 0;
    z-index: 99;
    width: 100% !important;
}

.wrap_head {
    display: block;
    width: 100%;
    height: 72px;
    transition: all 0.2s linear;
    background-color: #fff;

    .head_con {
        display: block;
        width: 1200px;
        height: 72px;
        margin: 0px auto;
        position: relative;
        z-index: 2;

        .logo {
            display: flex;
            align-items: center;
            width: 226px;
            height: 100%;
           

            img {
                display: inline-block;
                height: 36px;
                width: auto;
            }

            h1 {
                display: inline-block;
                font-size: 20px;
                display: block;
                color: #333333;
            }
        }

        .menu_list {
            display: block;
            height: 72px;
            position: absolute;
            left: 180px;
            top: 0px;
            cursor: pointer;
            opacity: 1;
            transition: opacity 0.3s linear;
            transform: translate(0px, 0);

            .menu_item {
                display: inline-block;
                height: 72px;
                float: left;
                margin-left: 72px;
                position: relative;

                .txt {
                    display: block;
                    height: 72px;
                    line-height: 72px;
                    font-size: 16px;
                    color: #999999;
                    opacity: 0.95;
                    position: relative;
                    z-index: 2;
                }

                &.active .txt {
                    color: #CD2312;
                }

                &.active::after {
                    content: '';
                    height: 2px;
                    width: 27px;
                    background-color: #CD2312;
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    transform: translateX(-50%);
                    border-radius: 1px;
                }


            }
        }

        .logo_area {
            display: block;
            position: absolute;
            right: 0px;
            top: 25px;
            font-size: 16px;
            color: #333333;
        }

        .user_area {
            display: flex;
            align-items: center;
            position: absolute;
            right: 0px;
            top: 25px;
            font-size: 16px;
            color: #333333;

            .nickName {
                margin-right: 12px;
                font-size: 16px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
                line-height: 20px;
            }

            .tx {
                width: 32px;
                height: 32px;
                border-radius: 50%;
            }
        }
    }
}

.logout {
    display: flex;
    align-items: center;
}
</style>
